/**
 * The hub: a round stone pad on its tile with a glowing ring set into it, where players arrive and
 * where the hub card opens. A player standing on it stands inside the ring.
 */
import * as THREE from 'three';

export const hubPad = (): THREE.BufferGeometry =>
  new THREE.CylinderGeometry(0.42, 0.46, 0.08, 28).translate(0, 0.04, 0);

export const hubRing = (): THREE.BufferGeometry =>
  new THREE.TorusGeometry(0.31, 0.024, 8, 48).rotateX(Math.PI / 2).translate(0, 0.085, 0);
